import {useState} from 'react';
import DOMPurify from 'dompurify';
import toast from 'react-hot-toast';

export function Case6({onPrevious, onFinalSubmit, formData}) {
    const [infoComplementaires, setInfoComplementaires] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validateInput()) {
            return;
        }

        const data = {infoComplementaires: sanitizeInput(infoComplementaires)};
        const finalData = {...formData, ...data};
        onFinalSubmit(finalData);
    };

    const validateInput = () => {
        // Ajoutez ici votre logique de validation personnalisée
        if (infoComplementaires.length > 4000) {
            toast.error('Les informations complémentaires doivent contenir au maximum 4000 caractères.');
            return false;
        }
        return true;
    };

    const sanitizeInput = (input) => {
        return DOMPurify.sanitize(input);
    };

    return (
        <div className="texte">
            <h5 className="centered"><b>Etape 5/5</b></h5>
            <hr/>
            <div className="centered">
                <h5><b>Informations complémentaires</b></h5>
            </div>
            <p>
                N'hésitez pas à indiquer toute information qui peut être utile au traitement de votre demande.
            </p>
            <div >
                <textarea className="form-control"
                    rows="4"
                    placeholder="Entrez vos informations complémentaires ici..."
                    value={infoComplementaires}
                    onChange={e => setInfoComplementaires(sanitizeInput(e.target.value))}
                />
            </div>
            <div className="app-buttons">
                <button className="buttons-secondaire" onClick={onPrevious}>Retour</button>
                <button className="buttons-primaire" onClick={handleSubmit}>Valider</button>
            </div>
        </div>
    );
}